import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { commissionerAgreementContract } from '/@/views/projectForPartner/commissionerManagement/agreement';

const projectForPartnerCommissionerAgreement: AppRouteModule = {
  path: commissionerAgreementContract.routePath,
  name: 'ProjectForPartnerCommissionerAgreementRoot',
  component: LAYOUT,
  meta: {
    title: '专员合作协议列表',
    hideMenu: true,
  },
  children: [
    {
      path: '',
      name: 'ProjectForPartnerCommissionerAgreement',
      component: () => import('/@/views/projectForPartner/commissionerManagement/cooperationAgreement.vue'),
      meta: {
        title: '专员合作协议列表',
        hideMenu: true,
        keepAlive: true,
        currentActiveMenu: '/commissioner/list',
      },
    },
  ],
};

export default projectForPartnerCommissionerAgreement;
